export default __webpack_public_path__ + "static/media/Ubuntu-Regular.abfd94df.woff";